import { default as Components } from './ComponentList';

export { Components };



// WEBPACK FOOTER //
// src/modules/screens/settings/Config/components/index.js